import React from 'react'
import { APP_DIR } from 'src/constants/routes'
import { Redirect, Route, Switch } from 'react-router-dom'
import Global from 'src/Components/buyers/Global/Global'
import Preview from 'src/features/preview'

import Root from './Root'
import AuthCallback from './AuthCallback'
import Styleguide from './Styleguide'
import App from './App'
import NotFound from './NotFound'

const getBuyerRedirect = props => `/${APP_DIR}/buy${props.match.url}`

const Routes = () => (
  <div>
    <Switch>
      <Route exact path='/' component={Root} />
      <Route exact path='/auth/callback' component={AuthCallback} />
      <Route path='/preview' component={Preview} />
      <Route path='/styleguide' component={Styleguide} />
      <Route path={`/${APP_DIR}`} component={App} />
      <Route
        exact
        path='/:buyerId([-0-9a-f]{36})?'
        render={props => <Redirect to={getBuyerRedirect(props)} />}
      />
      <Route component={NotFound} />
    </Switch>
    <Global />
  </div>
)

export default Routes
